import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-start" };
const _hoisted_2 = { class: "text-start" };
const _hoisted_3 = { class: "text-start" };
const _hoisted_4 = { class: "text-start" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", null, [
        _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.customer.id), 1),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.customer.firstname) + " " + _toDisplayString(_ctx.customer.lastname), 1),
        _createElementVNode("td", _hoisted_3, [
            _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.customer.street) + " " + _toDisplayString(_ctx.customer.unitNumber), 1),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.customer.postcode) + " " + _toDisplayString(_ctx.customer.city), 1)
            ])
        ]),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.customer.email), 1)
    ]));
}
